/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbstractStandardOperandValueImpl, AbstractStandardOperandValueImplBaseRecordClassFactory } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/AbstractStandardOperandValueImplBaseRecordClassFactory";
import { AbImmutableRecord } from "abreact/utils/AbImmutableRecord";
import { Assert } from "abweb/utils/Assert";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { NullUtils } from "abweb/utils/NullUtils";
import { ObjectUtils } from "abweb/utils/ObjectUtils";
import { Optional } from "abweb/utils/optional/Optional";
// import AbstractLeafOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractLeafOperandValue;
// import AbstractOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue;
// import WithoutNodeType = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue.WithoutNodeType;

const defaultState = {
  ...AbstractStandardOperandValueImpl.getDefaultState(),
  expExpressionNodeNodeType: undefined,
  operandName: undefined,
  // Defined in constructor
  value: undefined // Defined in constructor
};
export class AbstractLeafOperandValueImpl extends new AbstractStandardOperandValueImplBaseRecordClassFactory().createBaseRecordClass(defaultState) {
  constructor(state) {
    super(state);
  }
  get stringValue() {
    if (this.value != null) {
      Assert.assert(typeof this.value === "string");
      return this.value;
    }
  }
  get listValue() {
    if (this.value != null) {
      Assert.assert(typeof this.value !== "string");
      return this.value.value;
    }
  }
  withOperandName(operandName) {
    return this.with({
      operandName
    });
  }
  withValue(value) {
    return this.with({
      value: typeof value === "string" ? value : AbImmutableRecord.State.Object.from(value)
    });
  }
  stateWithoutNodeType() {
    return {
      ...super.stateWithoutNodeType(),
      operandName: this.operandName,
      value: this.value
    };
  }
  toExpExpressionNode() {
    const expExpressionNode = super.toExpExpressionNode();
    expExpressionNode.operandName = this.operandName;
    if (this.value != null) {
      this.applyValueToExpExpressionNode(expExpressionNode, this.value);
    }
    return expExpressionNode;
  }
  applyValueToExpExpressionNode(expExpressionNode, value) {
    if (value != null) {
      if (typeof value === "string") {
        expExpressionNode.value = value;
      } else {
        expExpressionNode.listValue = ObjectUtils.deepThaw(value.value);
      }
    }
  }
}
(function (_AbstractLeafOperandValueImpl) {
  function getDefaultState() {
    return defaultState;
  }
  _AbstractLeafOperandValueImpl.getDefaultState = getDefaultState;
  function isInstance(operandValue) {
    return ClassUtils.isInstanceOf(operandValue, AbstractLeafOperandValueImpl);
  }
  _AbstractLeafOperandValueImpl.isInstance = isInstance;
  function cast(operandValue) {
    Assert.assert(isInstance(operandValue));
    return operandValue;
  }
  _AbstractLeafOperandValueImpl.cast = cast;
  function castNullable(operandValue) {
    return Optional.of(operandValue).map(cast).get();
  }
  _AbstractLeafOperandValueImpl.castNullable = castNullable;
  function getRequiredPropertyValue(operandValue, property) {
    return NullUtils.getRequiredPropertyValue(cast(operandValue), property);
  }
  _AbstractLeafOperandValueImpl.getRequiredPropertyValue = getRequiredPropertyValue;
})(AbstractLeafOperandValueImpl || (AbstractLeafOperandValueImpl = {}));
//# sourceMappingURL=AbstractLeafOperandValueImpl.js.map
